import { Box } from '@mantine/core';

export default function CatalogContainer({ children, ...props }) {
  return (
    <Box p={'md'} {...props}>
      {children}
    </Box>
  );
}
